(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/components/bubble-usp.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/components/bubble-usp.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const _React = React,
  useRef = _React.useRef,
  useEffect = _React.useEffect,
  useState = _React.useState,
  useCallback = _React.useCallback,
  memo = _React.memo;
const _svs$tickets$play$uti = svs.tickets.play.utils.constants.ANIMATIONS,
  USP = _svs$tickets$play$uti.USP,
  USP_BACKGROUND = _svs$tickets$play$uti.USP_BACKGROUND;
const Image = svs.content.image_v2.Image;
const ImageMemo = memo(_ref => {
  let image = _ref.image;
  return React.createElement(Image, {
    image: _objectSpread(_objectSpread({}, image), {}, {
      sizes: 'min(320px, 75vw)'
    })
  });
});
setGlobal('svs.tickets.play.components.BubbleUsp', _ref2 => {
  let appTimeline = _ref2.appTimeline,
    ticketPitchImage = _ref2.ticketPitchImage,
    shouldPlayAnimation = _ref2.shouldPlayAnimation,
    onAnimationEnd = _ref2.onAnimationEnd,
    isFirstTime = _ref2.isFirstTime;
  const bubbleRef = useRef(null);
  const imgRef = useRef(null);
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasShownInitialUsp = _useState2[0],
    setHasShownInitialPromo = _useState2[1];
  const showUsp = useCallback(() => {
    const showTimeline = gsap.timeline();
    showTimeline.to(imgRef.current, USP.duration, {
      y: '-30%',
      ease: 'elastic.out(1, 0.4)'
    }, "showUsp+=".concat(USP.duration - USP_BACKGROUND.duration));
    showTimeline.to(bubbleRef.current, USP_BACKGROUND.duration, {
      background: 'rgba(0,0,0,0.5)',
      backdropFilter: 'blur(6px)',
      ease: 'linear',
      onStart: () => {
        bubbleRef.current && (bubbleRef.current.style.display = 'flex');
      }
    }, 'showUsp');
    return showTimeline;
  }, []);
  const hideUsp = useCallback(() => {
    const hideTimeline = new gsap.timeline();
    hideTimeline.to(imgRef.current, 1, {
      y: '-150%',
      ease: 'elastic.in(1.2, 0.75)'
    }, 'hideUsp');
    hideTimeline.to(bubbleRef.current, 0.6, {
      background: 'rgba(0,0,0,0)',
      backdropFilter: 'blur(0px)',
      ease: 'linear',
      onComplete: () => {
        bubbleRef.current && (bubbleRef.current.style.display = 'none');
        onAnimationEnd();
        setHasShownInitialPromo(true);
      }
    }, "hideUsp+=".concat(USP.duration - USP_BACKGROUND.duration));
    return hideTimeline;
  }, [onAnimationEnd]);
  useEffect(() => {
    if (isFirstTime) {
      var _imgRef$current;
      let unmounted = false;
      appTimeline.pause();
      const showTimeline = showUsp();
      const hideTimeline = hideUsp();
      appTimeline.add(showTimeline, 'showUsp');
      appTimeline.add(hideTimeline, 'hideUsp');
      appTimeline.pause();
      const resumeUsp = () => {
        if (unmounted) {
          return;
        }
        unmounted = true;
        setTimeout(() => {
          appTimeline.seek('showUsp');
          appTimeline.resume();
        }, 0);
      };
      const img = (_imgRef$current = imgRef.current) === null || _imgRef$current === void 0 ? void 0 : _imgRef$current.querySelector('img');
      if (img !== null && img !== void 0 && img.complete) {
        resumeUsp();
      } else if (img) {
        img.onload = resumeUsp;
        img.onerror = resumeUsp;
      }
      return () => {
        unmounted = true;
        showTimeline.kill();
        hideTimeline.kill();
      };
    }
    setHasShownInitialPromo(true);
  }, []);
  useEffect(() => {
    if (shouldPlayAnimation) {
      showUsp(0.4, true);
    }
  }, [shouldPlayAnimation, hasShownInitialUsp, showUsp]);
  return React.createElement("div", {
    className: "bubble-usp-overlay",
    onClick: () => {
      if (hasShownInitialUsp) {
        hideUsp();
      } else {
        appTimeline.seek('hideUsp');
      }
    },
    ref: bubbleRef
  }, React.createElement("div", {
    className: "bubble-usp-image",
    ref: imgRef
  }, React.createElement(ImageMemo, {
    image: ticketPitchImage
  })));
});

 })(window);